import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ToastContainer } from 'react-toastify';
import { LoadScript } from '@react-google-maps/api';
import 'react-toastify/dist/ReactToastify.css';

import theme from './theme';
import BookingFlow from './components/BookingFlow';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import FleetPage from './pages/FleetPage';
import FAQAndTerms from './pages/FAQAndTerms';

const libraries = ['places'];

function App() {
  const onError = (error) => {
    console.error('Error loading Google Maps:', error);
    // Log API key status (safely)
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    console.log('API Key status:', {
      exists: !!apiKey,
      length: apiKey ? apiKey.length : 0,
      firstChars: apiKey ? `${apiKey.substring(0, 8)}...` : 'N/A',
      environment: process.env.NODE_ENV
    });
    
    // Log the full error details
    if (error.message) {
      console.error('Error message:', error.message);
    }
    if (error.stack) {
      console.error('Error stack:', error.stack);
    }

    // Check if the error is related to billing
    if (error.message && error.message.includes('ApiNotActivatedMapError')) {
      console.error('This error typically means billing needs to be enabled in the Google Cloud Console');
    }
  };

  const onLoad = () => {
    console.log('Google Maps script loaded successfully');
    // Verify the Google Maps object is available
    if (window.google && window.google.maps) {
      console.log('Google Maps object is available');
      console.log('Available Google Maps APIs:', Object.keys(window.google.maps));
      if (window.google.maps.places) {
        console.log('Places library is available');
        console.log('Available Places APIs:', Object.keys(window.google.maps.places));
      } else {
        console.error('Places library is not available');
      }
    }
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}
      onError={onError}
      onLoad={onLoad}
      language="en"
      region="GB"
    >
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/fleet" element={<FleetPage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/booking-flow" element={<BookingFlow />} />
                <Route path="/faq-terms" element={<FAQAndTerms />} />
              </Routes>
            </Layout>
          </Router>
          <ToastContainer position="top-right" />
        </LocalizationProvider>
      </ThemeProvider>
    </LoadScript>
  );
}

export default App;
